import React, { useEffect, useState } from "react";
import NavBar from "../components/Navigation/NavBar";
import { getConfig, getConstant, handleHeader } from "../services/functions";
import { ABOUT_US_PATH, BASE_URL, CONTACT_US_PATH } from "../utility/path";
import axios from "axios";
import MainContainer from "../components/MainContainer";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import "../TnC.css";

const PrivacyPolicy = () => {
    const [state, setState] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        handleHeader({...getConstant("PRIVACY_POLICY")},dispatch);
    }, []);

    return (

        <>
            <NavBar />
            <MainContainer>
                <div className="tnc-page">
                    <div className="tnc-hero">
                        <div className="tnc-hero__icon">
                            <i className="fa fa-clipboard" />
                        </div>
                        <h3 className="tnc-hero__title">Privacy Policy</h3>
                        <p className="tnc-hero__sub">Last updated: April 2026</p>
                    </div>

                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">1</span>Introduction</div>
                    <div className="tnc-section__body">
                    Welcome to Gaufi ("the Platform"). This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our Platform. By accessing or using the Platform, you agree to the terms of this Privacy Policy.
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">2</span>Information We Collect</div>
                    <div className="tnc-section__body">
                    We collect various types of information to provide and improve our services:
                    <ul>
                        <li><b>Personal Information:</b> This includes information you provide when creating an account, such as your name, address, phone number, and professional details.</li>
                        <li><b>Usage Data:</b> We collect information about your interactions with the Platform, including search queries, pages visited, and other activities.</li>
                        <li><b>Device Information:</b> We collect information about the device you use to access the Platform, including IP address, browser type, and operating system.</li>
                        <li><b>Location Data:</b> We may collect and process information about your location to provide location-based services.</li>
                    </ul>
                    </div>
                    
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">3</span>How We Use Your Information</div>
                    <div className="tnc-section__body">
                    We use the information we collect for various purposes, including:
                    <ul>
                        <li><b>Providing Services:</b> To facilitate connections between Users and Professionals.</li>
                        <li><b>Improving Services:</b> To enhance the functionality and user experience of the Platform.</li>
                        <li><b>Communication:</b> To send you updates, notifications, and other information related to your use of the Platform.</li>
                        <li><b>Marketing:</b> To provide you with promotional materials and offers that may be of interest to you.</li>
                        <li><b>Compliance:</b> To comply with legal obligations and protect our legal rights.</li>
                    </ul>
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">4</span>Sharing Your Information</div>
                    <div className="tnc-section__body">
                    We do not sell, trade, or otherwise transfer your personal information to outside parties except as described below:
                    <ul>
                        <li><b>Service Providers:</b> We may share your information with third-party service providers who assist us in operating the Platform and providing services to you.</li>
                        <li><b>Legal Requirements:</b> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
                        <li><b>Business Transfers:</b> In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred to the acquiring entity.</li>
                    </ul>
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">5</span>Data Security</div>
                    <div className="tnc-section__body">
                    We implement a variety of security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                    </div>
                </div>
               
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">6</span>Your Rights</div>
                    <div className="tnc-section__body">
                    You have the right to:
                    <ul>
                        <li><b>Access:</b> Request access to the personal information we hold about you.</li>
                        <li><b>Correction:</b> Request correction of any inaccurate or incomplete information.</li>
                        <li><b>Deletion/Right to Erase:</b> Request the permanent deletion of your account and associated personal information, subject to certain exceptions <b>(detailed in Section 6A below)</b>. You can initiate this request directly within the website or app via the <b>[Profile &gt; Delete Account]</b> menu.</li>
                        <li><b>Opt-Out:</b> Opt-out of receiving marketing communications from us.</li>
                    </ul>
                    To exercise these rights, please contact us at <NavLink to={CONTACT_US_PATH}>Contact us</NavLink>.
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">6A</span>Account Deletion Process and Data Retention</div>
                    <div className="tnc-section__body">
                    When you request the deletion of your account, we follow a specific process to ensure your data is permanently removed while adhering to our legal obligations.
                    <ul>
                        <li className="mt-3"><b>Process:</b> You can initiate the account deletion request directly through the Platform's interface in <b>[Profile &gt; Delete Account].</b></li>
                        <li className="mt-3"><b>Data Deleted:</b> Upon successful completion of the deletion process, the following personal data will be permanently removed from our active databases: your name, phone number, address, professional details, saved preferences, usage data tied to your unique identifier, and search queries.</li>
                        <li className="mt-3"><b>Data Retained (Exceptions):</b> We may retain certain information for a limited period after deletion where retention is necessary:</li>
                        <ul className="ms-3">
                            <li>
                                <b>Legal Compliance:</b> We will retain transaction records, payment history, and communication records for a period of up to seven (7) years to comply with tax, accounting, and legal requirements.
                            </li>
                            <li>
                                <b>Security & Safety:</b> We may retain minimal information necessary to prevent fraud, abuse, and to protect the security of our services and other users.
                            </li>
                            <li>
                                <b>Anonymized Data:</b> Information may be retained in an aggregated or anonymized format that cannot be used to personally identify you.
                            </li>
                        </ul>
                        <li className="mt-3"><b>Deletion Timeline:</b> Your account and personal data will be permanently deleted from our active database immediately of receiving the request, except for data subject to legal retention obligations.</li>
                        <li className="mt-3"><b>Consequences:</b> Please be aware that deleting your account is irreversible. Once deleted, you will lose access to your profile, history, and any saved content or credentials.</li>
                    </ul>
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">7</span>Cookies and Tracking Technologies</div>
                    <div className="tnc-section__body">
                    The Platform reserves the right to modify these Terms at any time. Users will be notified of any significant changes, and continued use of the Platform will constitute acceptance of the revised Terms.
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">8</span>Children's Privacy</div>
                    <div className="tnc-section__body">
                    Our Platform is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information.
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">9</span>Changes to This Privacy Policy</div>
                    <div className="tnc-section__body">
                    We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
                    </div>
                </div>
                <div className="tnc-section">
                    <div className="tnc-section__heading"><span className="tnc-section__num">10</span>Contact Information</div>
                    <div className="tnc-section__body">
                    For any questions or concerns about these Terms, please contact us at <NavLink to={CONTACT_US_PATH}>Contact us</NavLink>.
                    </div>
                </div>

                 {/* Bottom links */}
                    <div className="tnc-links">
                        <NavLink to={ABOUT_US_PATH} className="tnc-link">
                            <i className="fa fa-info-circle" /> About Us
                        </NavLink>
                        <NavLink to={CONTACT_US_PATH} className="tnc-link">
                            <i className="fa fa-envelope" /> Contact Us
                        </NavLink>
                    </div>
                </div>
            </MainContainer>
        </>
    );
};

export default PrivacyPolicy;
